module.exports = __webpack_public_path__ + "static/img/图层 32.2af206e2.png";